<!--
 * @Author: cmchiu
 * @Date: 2022-08-31 14:22:55
 * @LastEditTime: 2022-09-02 17:57:42
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket\LearningMarket-ClientApp\src\App.vue
 * 
-->
<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',

    components: {},
}
</script>

<style>
html,
body {
    height: 100vh;
    margin: 0;
}
</style>
